module.exports = __webpack_public_path__ + "assets/usa-flag-md.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/usa-flag-md.png
// module id = 86
// module chunks = 7